import React from 'react';
import T from 'prop-types';

import SimpleDropdown from '../../Dropdowns/SimpleDropdown';
import { subDays, toJSDate } from '../../../utils/date';

const YearMonthForm = ({ date, localeUtils, maxPeriod, maxDate, frameless = true, onChange }) => {
  const minDate = toJSDate(subDays(maxDate, maxPeriod - 1));

  const minYear = minDate.getFullYear();
  const maxYear = maxDate.getFullYear();

  // Years
  const yearsList = [];
  const activeYear = date.getFullYear();

  for (let year = maxYear; year >= minYear; year -= 1) {
    yearsList.push({
      value: year,
      label: year.toString(),
    });
  }

  // Months
  const months = localeUtils.getMonths();
  const activeMonth = date.getMonth();

  let monthsList = months.map((month, index) => ({
    value: index,
    label: month,
  }));

  if (activeYear === minYear) {
    const minMonth = minDate.getMonth();
    monthsList = monthsList.map((month) => ({ ...month, disabled: month.value < minMonth }));
  }

  if (activeYear === maxYear) {
    const maxMonth = maxDate.getMonth();
    monthsList = monthsList.map((month) => ({ ...month, disabled: month.value > maxMonth }));
  }

  // Handlers
  const handleChange = (year, month) => {
    const hours = new Date().getHours();
    const minutes = new Date().getMinutes();

    onChange(new Date(year, month, 1, hours, minutes));
  };

  const handleMonthChange = (value) => {
    handleChange(activeYear, value);
  };

  const handleYearChange = (value) => {
    handleChange(value, activeMonth);
  };

  return (
    <div className="DayPicker-Caption">
      <SimpleDropdown
        selected={activeMonth}
        options={monthsList}
        frameless={frameless}
        menuWidth={160}
        portal={false}
        onChange={handleMonthChange}
      />
      <SimpleDropdown
        selected={activeYear}
        options={yearsList}
        frameless={frameless}
        menuWidth={120}
        portal={false}
        onChange={handleYearChange}
      />
    </div>
  );
};

YearMonthForm.propTypes = {
  onChange: T.func.isRequired,
  date: T.instanceOf(Date).isRequired,
  maxDate: T.instanceOf(Date).isRequired,
  localeUtils: T.object.isRequired,
  maxPeriod: T.number.isRequired,
  frameless: T.bool,
};

export default YearMonthForm;
